import React, { useEffect } from "react";
import { CountUp } from "countup.js";
import './css/CountDown.css';
import icon1 from './images/feature_1_1-1.png';
import icon2 from './images/feature_1_2-1.png';
import icon3 from './images/feature_1_3-1.png';
import icon4 from './images/feature_1_4-1.png';
import vvicon from './images/vigyanvriksh_praveensir.png';


const StatsSection = () => {
  useEffect(() => {
    const options = { duration: 2.5, separator: ",", suffix: "+" };
    const counters = [
      new CountUp("count1", 500, options),
      new CountUp("count2", 10000, options),
      new CountUp("count3", 500, options),
      new CountUp("count4", 100, options),
    ];
    counters.forEach((counter) => counter.start());
  }, []);

  return (
    <div className="countdown">
    <div className="container py-5">
      <div className="row align-items-center">
        
        {/* Left Section */}
        <div className="col-lg-6">
          <p className="text-danger fw-semibold">Transparent process</p>
          <h2 className="fw-bold">Why people <span className="section-titles">choose us</span></h2>
          <p className="text-muted">Trusted by CSIR NET, IIT GATE, IIT JAM, CUET PG, Assistant Professor, PGT, Geo chemist, BARC and other Chemistry Exam aspirants for expert guidance, proven results, and personalized learning support.</p>
          <div className="position-relative mt-4">
            <img
              src={vvicon}
              alt="Vigyan Vriksh"
              className="img-fluid rounded-circle"
            />
            <div
              className="position-absolute top-50 start-50 translate-middle bg-danger rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "60px", height: "60px", cursor: "pointer" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                fill="white"
                className="bi bi-play-fill"
                viewBox="0 0 16 16"
              >
                <path d="M11.596 8.697l-6.363 3.692A.5.5 0 0 1 4.5 12.002V3.998a.5.5 0 0 1 .733-.44l6.363 3.692a.5.5 0 0 1 0 .848z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="col-lg-6">
          <div className="row g-3">
            <div className="col-6">
              <div className="stat-card rounded-3 shadow-sm p-4 text-center">
                <img src={icon1} alt="Vigyan Vriksh Live Classes" />
                <div id="count1" className="stat-number fw-bold fs-1">0+</div>
                <p className="text-muted mb-0">Live Classes</p>
              </div>
            </div>
            <div className="col-6">
              <div className="stat-card rounded-3 shadow-sm p-4 text-center">
                <img src={icon2} alt="Vigyan Vriksh Question Preparation" />
                <div id="count2" className="stat-number fw-bold fs-1">0</div>
                <p className="text-muted mb-0">Question Preparation</p>
              </div>
            </div>
            <div className="col-6">
              <div className="stat-card rounded-3 shadow-sm p-4 text-center">
                <img src={icon3} alt="Vigyan Vriksh Basic Video" />
                <div id="count3" className="stat-number fw-bold fs-1">0</div>
                <p className="text-muted mb-0">Basic Video</p>
              </div>
            </div>
            <div className="col-6">
              <div className="stat-card rounded-3 shadow-sm p-4 text-center">
                <img src={icon4} alt="Vigyan Vriksh Mock Preparation Test" />
                <div id="count4" className="stat-number fw-bold fs-1">0</div>
                <p className="text-muted mb-0">Mock Preparation Test</p>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    </div>
  );
};

export default StatsSection;
